export const PROFILECARD_WITH_ATLAS_FEATURES_ENABLED_FF =
	'confluence.frontend.enable.profilecard.with.atlas.features';
export const DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
export const TEAMCENTRAL_GRAPHQL_PATH = '/gateway/api/watermelon/graphql';
